import { Route } from '@angular/router';
import { AccessesComponent } from 'app/components/accesses/accesses.component';
import { AuthGuard } from 'app/common/services/auth-guard.service';

export const accessesRoute: Route = {
  path: ':cityId/accesses',
  component: AccessesComponent,
  canActivate: [AuthGuard],
  data: { title: 'Доступы - администратор' }
};


